<template>
  <el-footer class="footer-box">
    <div class="content title">上海斯选网络科技有限公司</div>
    <div class="content desc">Copyright © 2017 - 2022 Ostay. All Rights Reserved.</div>
  </el-footer>
</template>

<script>
export default {
  name: 'Footer',
}
</script>

<style scoped lang="scss">
.footer-box {
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 1000;
  background-color: #f5f6f5;
  color: #bbbbbb;
  border: none;
  text-align: center;
  outline: 1px solid #ebebeb;
  .content {
    color: #777;
    font-size: 12px;
    line-height: 20px;

    &.title {
      margin-top: 10px;
    }
  }
}
</style>
